import React from 'react'

const PatientEdit = () => {
  return (
    <div>PatientEdit</div>
  )
}

export default PatientEdit